import React from 'react';
import { useTranslation } from 'react-i18next';

const ExportModal = ({ activeProject, onClose, exportAsText, openXComposer, openThreadsComposer }) => {
  const { t } = useTranslation();

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, backdropFilter: 'blur(8px)', animation: 'fadeIn 0.2s ease' }} onClick={onClose}>
      <div style={{ background: 'var(--bg-card)', borderRadius: '20px', padding: '32px', width: '100%', maxWidth: '380px', boxShadow: 'var(--shadow-lg)', border: '1px solid var(--border-color)', animation: 'modalIn 0.3s cubic-bezier(0.16, 1, 0.3, 1)' }} onClick={e => e.stopPropagation()}>
        <h2 style={{ fontSize: '24px', fontWeight: '700', marginBottom: '24px', textAlign: 'center', color: 'var(--text-primary)' }}>{t('export.title')}</h2>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '20px' }}>
          {[
            { label: '📄 ' + t('export.downloadTxt'), action: exportAsText },
            { label: activeProject?.type === 'article' ? '𝕏 ' + t('export.exportToX') : '𝕏 ' + t('export.postToX'), action: openXComposer },
            { label: '📱 ' + t('export.postToThreads'), action: openThreadsComposer }
          ].map((opt, i) => (
            <button
              key={i}
              style={{ padding: '16px', borderRadius: '12px', border: '2px solid var(--border-color)', background: 'var(--bg-secondary)', color: 'var(--text-primary)', fontSize: '15px', fontWeight: '500', cursor: 'pointer', fontFamily: 'inherit', textAlign: 'left', transition: 'all 0.2s' }}
              onClick={opt.action}
              onMouseEnter={e => e.target.style.borderColor = 'var(--accent-primary)'}
              onMouseLeave={e => e.target.style.borderColor = 'var(--border-color)'}
            >
              {opt.label}
            </button>
          ))}
        </div>
        <button
          style={{ width: '100%', padding: '14px', borderRadius: '12px', border: '2px solid var(--border-color)', background: 'transparent', color: 'var(--text-secondary)', fontSize: '14px', cursor: 'pointer', fontFamily: 'inherit' }}
          onClick={onClose}
        >
          {t('export.cancel')}
        </button>
      </div>
    </div>
  );
};

export default ExportModal;
